import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { PrivacyEducationArticleComponent } from './privacy-education-article.component';
import { DirectivesModule } from '../../../../common/components/directives.module';
import { SharedModule } from '../../../../common/components/shared.module';
import { UiCardModule } from '../../../../common/components/ui/ui-card/ui-card.module';
import { PipesModule } from '../../../../common/pipes/pipes.module';
import { PrivacyEducationAsideModule } from '../privacy-education-aside/privacy-education-aside.module';
import { EmptyStateModule } from '../../../../common/components/empty-state/empty-state.module';

const PrivacyEducationArticleRoutes: Routes = [
    { path: '', component: PrivacyEducationArticleComponent }
];

@NgModule({
    declarations: [
        PrivacyEducationArticleComponent
    ],
    imports: [
        RouterModule.forChild(PrivacyEducationArticleRoutes),
        UiCardModule,
        SharedModule,
        PipesModule,
        PrivacyEducationAsideModule,
        DirectivesModule,
        EmptyStateModule
    ],
    exports: [PrivacyEducationArticleComponent]
})

export class PrivacyEducationArticleModule { }
